import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function GuaranteeSection() {
  return <section className="bg-brand-main px-5 py-16 md:py-20" data-id="element-74" data-mp="4vs1604r2hrx">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-75" data-mp="9ttk8l26eh3e">
        <div className="mb-6 inline-flex h-16 w-16 items-center justify-center rounded-full bg-brand-orange/10" data-id="element-76" data-mp="9wfqmhdbyqk1">
          <ShieldCheckIcon className="h-8 w-8 text-brand-orange" strokeWidth={1.5} aria-hidden="true" data-id="element-77" data-mp="er37bu23ego2" />
        </div>
        <h2 className="text-2xl font-extrabold text-brand-navy md:text-3xl" data-id="element-78" data-mp="nskufwdx3im9">
          Geld zurück oder behalten.
        </h2>
        <p className="mt-5 text-sm leading-relaxed text-brand-gray md:text-base" data-id="element-79" data-mp="smxd447kkpwy">
          Teste Musik Startklar 30 Tage risikofrei. Wenn es deinen Unterricht
          nicht leichter macht, bekommst du dein Geld zurück – ohne Fragen. Und
          du darfst alles behalten.
        </p>
      </Reveal>
    </section>;
}